import Alert from '@risk-smart/themed-cloudscape-components/alert';
import CopyToClipboard from '@risk-smart/themed-cloudscape-components/copy-to-clipboard';
import FormField from '@risk-smart/themed-cloudscape-components/form-field';
import Input from '@risk-smart/themed-cloudscape-components/input';
import SpaceBetween from '@risk-smart/themed-cloudscape-components/space-between';
import Button from '@risksmart-app/components/src/button';
import { useTranslation } from 'react-i18next';

interface Props {
  secret: string;
  onConfirm: () => void;
}

export const WebhookSecretReveal = ({ secret, onConfirm }: Props) => {
  const { t } = useTranslation(['common'], {
    keyPrefix: 'webhooks.secret_reveal',
  });

  return (
    <SpaceBetween size={'l'}>
      <Alert type={'warning'}>{t('warning')}</Alert>
      <FormField label={t('secret_label')}>
        <Input value={secret} readOnly type={'password'} />
      </FormField>
      <CopyToClipboard
        copyButtonText={t('copy_label')}
        textToCopy={secret}
        copySuccessText={t('copy_success_text')}
        copyErrorText={t('copy_error_text')}
      />
      <SpaceBetween direction={'horizontal'} size={'xs'}>
        <Button variant={'primary'} onClick={onConfirm}>
          {t('done_button')}
        </Button>
      </SpaceBetween>
    </SpaceBetween>
  );
};

export default WebhookSecretReveal;
